module.exports = __webpack_public_path__ + "static/media/Timber-Ridge-Declarations-Covenants.3392529a.pdf";